module.exports = __webpack_public_path__ + "img/control_device3.2a8ed76c.png";